// let chrome = {}
export let BASE_URL
export let PORT

// constants file
export const MX_PANEL_KEY = process.env.VUE_APP_MX_PANEL_KEY

export const TRACK_MIXPANEL = 'trackMixpanel'
export const MX_SIGNUP_LINK_CLICKED = 'LinkedIn - Sign Up Clicked'
export const MX_SF_SIGNUP_LINK_CLICKED = 'SF - Sign Up Clicked'
export const MX_CUSTOM_DOMAIN_GET_EMAIL = 'Get email - custom domain'
export const MX_TRY_FOR_DIFF_DOMAIN_SHOWN = 'Try for a different domain clicked'
export const VIEW_SIMILAR_CONTACT_FROM_EMAIL_FOUND =
  'LI - View similar contact from email found section'
export const MX_GET_EMAIL_SN =
  'linkedIn SalesNavigator single profile- get contact'
export const MX_UPGRADE_CLICKED = ' linkedin - Getmore Email Lookup clicked'
export const MX_UPGRADE_SHOWN = ' linkedin - Getmore Email Lookup shown'
export const MX_ERR_SHOWN = 'something went wrong message shown'
export const MX_DOMAIN_NOT_FOUND_SHOWN = 'domain not found msg shown'

export const MX_SIMILAR_CONTACT_SHOWN =
  'linkedIn - Similar Contacts Section Shown'
export const MX_SIMILAR_CONTACT_CLICKED =
  'linkedIn - Similar Contacts Section Clicked'
export const MX_GET_EMAIL_ADV_SRCH = 'linkedIn advance search- get contact'
export const LINKEDIN_SINGLE = 'linkedin_single'
export const LINKEDIN_SN = 'linkedin_sn'
export const GMAIL = 'gmail'
export const POPUP = 'popup'
export const MX_ADD_TO_CRM_CLICKED_LP = 'LP - SF CRM - Add to crm clicked'
export const MX_CONTACT_PURCHASED = 'Contact Purchased'
export const MX_VIEW_SIMILAR_CONTACTS_OTHER_DOMAIN =
  'LP - View Similar contacts - Other Domain'
export const MX_VIEW_ON_LINKEDIN_CLICKED =
  'AP - View company on Linkedin clicked'

export const MX_REVIEW_2_YES_CLICKED = 'AP - Review - Chrome store redirected'
export const MX_REVIEW_3_YES_CLICKED = 'AP - Review - Feedback mail'
export const MX_REVIEW_NO_CLICKED = 'AP - Review not given'
export const MX_REVIEW_SECTION_SHOWED = 'AP - Review section showed'
export const MX_AE_SCHEDULE_EMAIL_CLICKED = 'AP - AE Schedule email clicked'
export const MX_FEEDBACK_MSG_GIVEN = 'AP - Review - Feedback given'

/* Mixpanel for slaesforce */
export const MX_SF_GET_EMAIL_FROM_RIGHT_CLICK =
  'SF - Get Email from Right Click'
export const MX_SF_GET_EMAIL_FROM_SLIDER = 'SF - Get Email form Slider'

export const MX_AP_EMAIL_FOUND = 'AP - Email found'
export const MX_AP_EMAIL_NOT_FOUND = 'AP - Email not found'
export const MX_AGREE_TERMS_CONDITIONS_CLICKED =
  'AP - Agree Terms & condition clicked'

/* Mixpanel for Campaign manager */
export const LOG_DOM_CHANGE_URL = `/lp/domchange.htm`
export const DOM_CHANGE_UPDATE_PLUGIN =
  'AP - linkedin dom change: Update plugin'
export const DOM_CHANGE_FIX_IN_PROGRESS =
  'AP - linkedin dom change: Fix In Progress '

export const AE_PROMO_SHOWED = 'aePromoButtonShowed'

//new added
export const MX_SF_EXPORT_COMPLETE = 'LP - SF CRM completed'

export const MxEvent = {
  bulkContactEmailFound: 'AP - Bulk Contact Card Email Found',
  bulkContactEmailNotFound: 'AP - Bulk Contact Card Email Not Found',
  GET_ALL_CLICKED: 'AP - Bulk Mode: Get all clicked',
  addToList: 'AP - Add To List',
  upgradeLockShown: 'AP - Upgrade to View Phone Lock Shown',
  upgradeTooltip: 'AP - Upgrade to View Phone Clicked',
  upgradeTooltipHovered: 'AP - Upgrade to View Phone Lock Hovered',
  toggleDockView: 'AP - Switch Dock View Clicked',
  viewAllLeads: 'AP - SP View All Contacts',
  connectToLinkedinShown: 'AP - Connect Linkedin popup shown',
  connectToLinkedInBtnClicked: 'AP - Connect LinkedIn Button Clicked',
  connectToLinkedInSuccess: 'AP - Connect LinkedIn Success',
  connectToLinkedInFail: 'AP - Connect LinkedIn Failure',
  connectToLinkedInSkip: 'AP - Connect LinkedIn Skip',
  connectToLinkedInClose: 'AP - Connect LinkedIn Close',
  payWallViewed: 'AP - Paywall Viewed',
  payWallClicked: 'AP - Paywall Clicked',
  payWallClosed: 'AP - Paywall Closed',
  crmRedirect: 'AP - CRM Redirect Clicked',
  tryDifferentDomain: 'AP - Try Different Domain Edit Clicked',
  followLinkedinShown: 'AP - Follow Linkedin Shown',
  followLinkedinClick: 'AP - Follow Linkedin Click',
  followLinkedinClose: 'AP - Follow Linkedin Close',
  signUpLimitError: 'Limited Domain Registration Error',
  signUpNonBusinessEmailError: 'Non Business Email Registration Error',
  googleSignupFailed: 'Google signup failed',
  dailyLimitG2Review: 'DL - G2 review clicked',
  aeBannerShown: 'AE - AP Banner Shown',
  aeBannerClicked: 'AE - AP Banner Clicked',
  aeContactExported: 'AE - AP Contact Exported',
  aeContactLimitUpgrade: 'AE - AP Contact Limit Upgrade Shown',
  aeContactUpgradeRedirect: 'AE - AP Contact Limit Redirect Pricing',
  aeContactDuplicatePopup: 'AE - AP Contact Duplicate Popup Shown',
  aeIconClicked: 'AE - AP Icon Clicked',
  aeAddExpContactClicked: 'AE - AP Add to Export Contact Clicked',
  aeAddSequenceClicked: 'AE - AP Add to Sequence Clicked',
  aeCreateSeqShown: 'AE - AP Create Sequence Shown',
  aeCreateSeqClicked: 'AE - AP Create Sequence Clicked',
  aeAddEmailAccountShown: 'AE - AP Add Email Account Shown',
  aeAddEmailAccountClicked: 'AE - AP Add Email Account Clicked',
  aeAddSeq: 'AE - AP Added to Sequence',
  aeSequenceStarted: 'AE - Sequence started',
  aeScheduleClicked: 'AE - AP Schedule Now Clicked',
  aeProceedTp: 'AE - AP Proceed Tooltip',
  upgradeHeaderRocket: 'AP - Pricing Redirect',
  aeExportBannerShown: 'AP - AE banner shown',
  aeBannerTryNowBtnClick: 'AP - AE banner clicked',
  aeProductPage: 'AP - AE Wordpress Product Page',
  singleContactViewed: 'AP - LI-Single-Contact-Onload',
  singleContactViewedSN: 'AP - LISN-Single-Contact-Onload',
  singleContactPurchased: 'AP - LI-Single-Contact-Purchased',
  singleContactPurchasedSN: 'AP - LISN-Single-Contact-Purchased',
  mobileNumberPurchased: 'AP - LI-Mobile-Number-Purchased',
  mobileNumberPurchasedSN: 'AP - LISN-Mobile-Number-Purchased',
  bulkContactViewed: 'AP - LI-Bulk-Onload',
  bulkContactViewedSN: 'AP - LISN-Bulk-Onload'
}

export let GA_KEY = 'UA-118041086-1'
export const ONBOARDING_CLICKED = 'AP - Onboarding Clicked'
export const ONBOARDING_SHOWN = 'AP - Onboarding Shown'
export const ACTIVATION_POPUP_SHOWN = 'AP - Activation popup shown'
export const RESEND_ACTIVATION_CLICKED = 'AP - Resend activation clicked'

export const HttpUrl = {
  addContactToList: 'li/purchase/v3/contacts.htm',
  addContactToListV2: 'li/purchase/addContactToList.htm',
  fetchAllList: 'li/lists.htm',
  createList: 'li/lists/create.htm',
  linkedinFollow: 'li/linkedin/follow.htm',
  getMemberDetails: 'lp/getMemberDetails.htm',
  exSingleContactToAe: '/contact/single.htm',
  exUpdateSingleContactToAe: '/contact/update.htm',
  getFeatureFlag:
    'memberattribute/getmemberattribute.htm?attributeId=FEATURE_FLAG',
  customFields: '/customFields.htm',
  validateApiKey: '/salesgear/isConnected.htm'
}
